import InformationIconSolid from '@/components/icons/InformationIconSolid';
import { FC } from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SettingsFormData } from '@/features/settings/SettingsPage';
import ELogoUploaderForm from '@/components/everridge/ELogoUploaderForm';
import { cn } from '@/lib/utils';

type Props = {
	control: Control<SettingsFormData>;
	isMobile?: boolean;
};

const SettingsLogo: FC<Props> = ({ control, isMobile }) => {
	const { t } = useTranslation();

	return (
		<div
			className={cn(
				'w-1/2 p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10',
				isMobile && 'w-full p-0 border-0 bg-popover-30',
			)}>
			<h3 className={cn(isMobile && 'text-base')}>
				{t('main.settings.components.logo.title')}
			</h3>
			<ELogoUploaderForm
				control={control}
				fieldName={'logo'}
				label={t('elements.form.logo.label')}
				placeholder={t('elements.form.logo.placeholder')}
			/>
			<div className='p-3.5 flex gap-2 border border-popover-100 rounded-semi-xl bg-popover-10'>
				<InformationIconSolid className='size-4 shrink-0' />
				<p className='text-xs font-medium text-popover-800'>
					{t('main.settings.components.logo.text')}
				</p>
			</div>
		</div>
	);
};

export default SettingsLogo;
